import React, { useEffect, useState } from 'react';
import axios from 'axios';
import useMoengage from '../../../hooks/useMoengage';

const DynamicMitraPage = () => {
  const trackEvent = useMoengage()[1];
  const [image, setImage] = useState('');
  const [key, setKey] = useState('');
  const [landingUrl, setLandingUrl] = useState('');

  const fetchDynamicMitraPages = () => {
    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_API_HOST}/v2/app/dynamicMitraPage`,
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': '*',
        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
        'Access-Control-Allow-Headers':
          'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
        'Cache-Control': null,
        'X-Requested-With': null,
      },
    };

    return axios(config).then(response => {
      if (response.status === 200) {
        const res = response.data;
        const arr = res.dynamicMitraUrl;
        return arr;
      }
      throw new Error('Server Error');
    });
  };
  useEffect(async () => {
    const paramString = window.location.href.split('/');
    const userIdParam = paramString[paramString.length - 1];
    const obj = await fetchDynamicMitraPages();
    if (obj) {
      const show = obj.filter(x => x.key === userIdParam);
      if (show[0]) setImage(show[0].imageUrl);
      if (show[0]) setLandingUrl(show[0].landingUrl);
      if (show[0]) setKey(userIdParam);
    }
  }, []);

  const knowMore = () => {
    window.open(landingUrl);
    trackEvent(key);
  };

  return (
    <>
      <div>
        {' '}
        <img
          src={image}
          onClick={knowMore}
          alt="logo"
          width="100%"
          id="oneCode"
          style={{ marginLeft: '-1px', cursor: 'pointer' }}
        />
      </div>
    </>
  );
};
export default DynamicMitraPage;
